module.exports = __webpack_public_path__ + "static/media/logo-transparant.9545e51e.png";